module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.hourSlots(_vm.minStartTime, '23:45', _vm.periodInMins),
      "label": "Start time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.hourSlots(_vm.startTime || _vm.minStartTime, '23:45', _vm.periodInMins),
      "label": "End time"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465affaa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/TimeRangePicker.vue
// module id = 1412
// module chunks = 9